export const STATIC_CONTENT_TYPE = {
    TERM_OF_USE: "TERM_OF_USE",
    PRIVACY_POLICY: "PRIVACY_POLICY",
};
